import React, {useState, useEffect, useLayoutEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Link, useParams} from 'react-router-dom';
import MotifCard from '@ey/motif-react-wrapper/Card';
import styled from 'styled-components';
import {serviceURL, promiseAreas, UserType} from '../../util/uiconstants';
import env from '../../util/env';
import {labels, currentResource} from '../../util/utils';
import {SVGICONS} from '@ey/icons';
import Utility from '../../util/utilityfunctions';
import {raiseJSValidationError} from '../../actions/erroractions';

const AdminHomePage = () => {
	const userPreferences = useSelector((store) => store.userPreferences);
	const [isUserAdmin, setisUserAdmin] = useState(false);

	const dispatch = useDispatch();
	useEffect(() => {
		if (
			userPreferences.isPreferencesLoaded &&
			(!userPreferences.userType == 'Admin' ||
				(!userPreferences.isAdminReader && !userPreferences.isAdminWriter && !userPreferences.isSuperAdmin))
		) {
			// this is to let the current resource acquire the language first and then display the message
			setTimeout(() => {
				dispatch(raiseJSValidationError(currentResource.AdminUserErrors.userError));
			}, 900);
		}
	}, [userPreferences]);

	useLayoutEffect(() => {});

	return (
		<StyledContainer className="mainResponsiveWrapper">
			{userPreferences.userType == 'Admin' && <h2 className="welcome-text">{labels.mainPageInstructionalText}</h2>}
			<section className="cards-holder">
				{(userPreferences.isAdminReader || userPreferences.isAdminWriter || userPreferences.isSuperAdmin) && (
					<>
						<Link
							className="admin-card-link"
							to={'/admin/manageprojects'}
							title={Utility.removeTags(labels.manageProjectsFormatted)}
						>
							<MotifCard className="">
								<section className="manage-button">
									<span className="icon-holder">
										<SVGICONS
											styleName="xtra-large"
											hoverText={Utility.removeTags(labels.manageProjectsFormatted)}
											name="engagements"
										/>
									</span>
									<span className="card-label" title={Utility.removeTags(labels.manageProjectsFormatted)}>
										{Utility.createRichTextElement(labels.manageProjectsFormatted)}
									</span>
								</section>
							</MotifCard>
						</Link>
						<Link
							className="admin-card-link"
							to={'/admin/manageusers'}
							title={Utility.removeTags(labels.manageUsersFomatted)}
						>
							<MotifCard>
								<section className="manage-button">
									<span className="icon-holder">
										<SVGICONS
											styleName="xtra-large"
											hoverText={Utility.removeTags(labels.manageUsersFomatted)}
											name="manage-access"
										/>
									</span>
									<span className="card-label" title={Utility.removeTags(labels.manageUsersFomatted)}>
										{Utility.createRichTextElement(labels.manageUsersFomatted)}
									</span>
								</section>
							</MotifCard>
						</Link>
					</>
				)}
				{userPreferences.isSuperAdmin && (
					<Link
						className="admin-card-link"
						to={'/admin/manageadmins'}
						title={Utility.removeTags(labels.manageAdminsFormatted)}
					>
						<MotifCard>
							<section className="manage-button">
								<span className="icon-holder">
									<SVGICONS
										styleName="xtra-large"
										hoverText={Utility.removeTags(labels.manageAdminsFormatted)}
										name="permission-groups"
									/>
								</span>
								<span className="card-label" title={Utility.removeTags(labels.manageAdminsFormatted)}>
									{Utility.createRichTextElement(labels.manageAdminsFormatted)}
								</span>
							</section>
						</MotifCard>
					</Link>
				)}
			</section>
		</StyledContainer>
	);
};

export default AdminHomePage;

const StyledContainer = styled.section`
	padding: 5rem 6rem;
	width: 100%;
	.welcome-text {
		font-size: 2.4rem;
		font-weight: 300;
		margin: 0;
		padding: 0;
	}

	.admin-card-link {
		color: ${(props) => props.theme.color[`blue600yellow400`]};
		&:hover {
			color: ${(props) => props.theme.color[`blue600yellow400`]};
		}
	}

	.cards-holder {
		display: flex;
		margin-top: 3.9rem;
	}

	.motif-card {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 4rem;
		width: 22rem;
		height: 20rem;

		.manage-button {
			text-align: center;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}

		.icon-holder {
			.xtra-large {
				width: 5.4rem;
				height: 5.4rem;
				max-width: 5.4rem;
				max-height: 5.4rem;
				fill: ${(props) => props.theme.color[`grey500`]};
			}
		}

		.card-label {
			max-width: 14rem;
			word-wrap: break-word;
			white-space: break-spaces;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
			margin-top: 2rem;
			height: 5rem;
		}
		font-size: 1.6rem;
		font-weight: bold;
	}

	.hidden {
		display: none;
	}

	.ellipsis {
		display: inline-block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;
